import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import useMediaQuery from '@mui/material/useMediaQuery';
import { BottomSheet } from '../new_components/BottomSheet';


export function AwaitPaymentModal({ isOpen, messageTitle, showContentAction, ContentAction, title, onHide, useDrawer = false }) {
    const isMobile = useMediaQuery('(max-width: 767px)');

    const handleClose = () => {
        onHide();
    };

    if (useDrawer) {
        return (
            <BottomSheet
                open={isOpen}
                isDesktop={!isMobile}
                onOpenChange={onHide}
                variant="light"
                headerContent={<h2 className="font-semibold2 text-xl">{title}</h2>}
            >
                <div className="w-full flex flex-col items-center gap-4">
                    {messageTitle && <p className="text-center">{messageTitle}</p>}
                    {showContentAction && ContentAction}
                </div>
            </BottomSheet>
        );
    }

    return (
        <div>

            <Dialog
                disableEscapeKeyDown={true}
                open={isOpen}
                onClose={onHide}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth={'xs'}
                fullWidth={true}
            >

                <DialogTitle style={{ fontWeight: 'bolder', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-title">
                    {title}
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <DialogContentText style={{ color: 'grey', fontFamily: 'GT Walsheim Pro' }} id="alert-dialog-description">
                        {messageTitle}
                    </DialogContentText>
                </DialogContent>

                <DialogActions>
                    {showContentAction && (ContentAction)}
                </DialogActions>
            </Dialog>

        </div>
    );
}
